import {
    IconBook,
    IconFlame,
    IconFlask,
    IconMoodSmileBeam,
    IconSchool,
} from "@tabler/icons-react";

// Voices the creator can pick for the script. The keys travel to
// platform-builder-server as `personality` (ContentVideoScriptDTO); the
// prompt there carries the actual writing guidance for each one. Labels and
// hints live in contentModals:generateScript.personality.options.
export const PERSONALITY_OPTIONS = [
    { key: "didactic", Icon: IconSchool },
    { key: "casual", Icon: IconMoodSmileBeam },
    { key: "motivational", Icon: IconFlame },
    { key: "technical", Icon: IconFlask },
    { key: "storyteller", Icon: IconBook },
];

export const DEFAULT_PERSONALITY = "didactic";
